import { setIn } from 'immutable';
export function findGeozone(geozones, find_geozone_id) {
    const id = typeof find_geozone_id === 'object' ? find_geozone_id._id : find_geozone_id;
    return geozones.filter((geozone) => geozone._id === id);
}
export function findGeozoneIndex(geozones, find_geozone) {
    const id = typeof find_geozone === 'object' ? find_geozone._id : find_geozone;
    return geozones.findIndex((geozone) => geozone._id === id);
}
export function addToGeozoneRedux(geozones, new_geojson, new_geojson_id, user_id) {
    //Проверяем, нет ли такого?
    const isNew = findGeozone(geozones, new_geojson_id);
    //Добавляем новый элемент
    if (isNew.length === 0)
        return setIn(geozones, [], [...geozones, { geojson: new_geojson, _id: new_geojson_id, user_id }]);
    return geozones;
}
export function deleteInGeozoneRedux(geozones, delete_geozones) {
    if (delete_geozones.length === 0)
        return geozones;
    const delete_geozones_ids = delete_geozones.map((gz) => gz._id);
    return geozones.filter((geo) => !delete_geozones_ids.includes(geo._id));
}
export const filterGeozones = (geozones, geozones_id) => {
    let changes = 0;
    const new_geozones = geozones.filter((geozone) => {
        if (geozones_id.includes(geozone._id)) {
            changes++;
            return false;
        }
        return true;
    });
    if (changes === 0)
        return geozones;
    return new_geozones;
};
export function editInGeozoneRedux(geozones, edited_geozones, from_old_program = false) {
    //Если удалили элементы
    if (from_old_program && edited_geozones.length < geozones.length) {
        return edited_geozones;
    }
    let new_geozones = geozones;
    //Надо просмотреть массив новых элементов
    edited_geozones.forEach((edit_gz) => {
        //Найти какой элемент изменили
        const id = findGeozoneIndex(geozones, edit_gz);
        //Значит добавили
        if (id === -1) {
            new_geozones = setIn(new_geozones, [], [...new_geozones, edit_gz]);
            return;
        }
        //Заменить его на новый элемент || найти заменённый значения и вставить их
        new_geozones = setIn(new_geozones, [], [...new_geozones.slice(0, id), edit_gz, ...new_geozones.slice(id + 1)]);
    });
    //Вернуть измененный массив
    return new_geozones;
}
export function uploadToGeozoneRedux(geozones, user_id, geozones_arr) {
    geozones_arr.map((upload_gz) => {
        const isNew = findGeozone(geozones, upload_gz.geozone_id);
        if (isNew.length === 0)
            setIn(geozones, [], [
                ...geozones,
                {
                    geojson: upload_gz.geozone,
                    _id: upload_gz.geozone_id,
                    user_id,
                },
            ]);
    });
    return geozones;
}
